import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import VersionExplorer from './components/VersionExplorer';
import VersionCompare from './components/VersionCompare';
import SubtitlePreview from './components/SubtitlePreview';
import EpisodeList from './components/EpisodeList';
import SubtitleGroups from './components/SubtitleGroups';
import WatchGuide from './components/WatchGuide';
import FaqSection from './components/FaqSection';
import UpdateLog from './components/UpdateLog';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <VersionExplorer />
        <VersionCompare />
        <SubtitlePreview />
        <EpisodeList />
        <SubtitleGroups />
        <WatchGuide />
        <FaqSection />
        <UpdateLog />
      </main>
      <SiteFooter />
    </div>
  );
}